export const ABUSIVE_RATE_EXCESS_PERCENT = 50;
export const RATE_ABUSIVENESS_EXCLUDED_CATEGORIES = [
  "RCC",
  "RMC",
  "PRESTAMISTA",
];

export const isRateAbusivenessApplicable = (category) => {
  if (!category) {
    return true;
  }
  return !RATE_ABUSIVENESS_EXCLUDED_CATEGORIES.includes(String(category).trim().toUpperCase());
};

export const getRateExcessPercent = (contractedRate, averageRate) => {
  const contracted = Number(contractedRate);
  const average = Number(averageRate);
  if (!Number.isFinite(contracted) || !Number.isFinite(average) || contracted <= 0 || average <= 0) {
    return null;
  }
  return ((contracted - average) / average) * 100;
};

export const isRateBelowAbusiveThreshold = (contractedRate, averageRate, category) => {
  if (!isRateAbusivenessApplicable(category)) {
    return false;
  }
  const percent = getRateExcessPercent(contractedRate, averageRate);
  if (percent === null) {
    return false;
  }
  return percent < ABUSIVE_RATE_EXCESS_PERCENT;
};

const formatExcessRelation = (percent) => {
  const formatted = Math.abs(percent).toLocaleString("pt-BR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
  });
  if (percent < 0) {
    return `está ${formatted}% abaixo da média`;
  }
  if (percent === 0) {
    return "é igual à média";
  }
  return `está ${formatted}% acima da média`;
};

export const formatRateAbusivenessMessage = (contractedRate, averageRate, excessPercent) => {
  const percent =
    excessPercent === undefined || excessPercent === null
      ? getRateExcessPercent(contractedRate, averageRate)
      : Number(excessPercent);

  if (percent === null || !Number.isFinite(percent)) {
    return (
      "A taxa contratada não está 50% acima da média. " +
      "Este contrato pode não ser considerado abusivo."
    );
  }

  return (
    `A taxa contratada ${formatExcessRelation(percent)}. ` +
    "O critério de abusividade exige pelo menos 50% acima da taxa média. " +
    "Este contrato pode não ser considerado abusivo."
  );
};

export const confirmGenerateDespiteNonAbusiveRate = (contract) => {
  const isBelow =
    contract?.is_rate_below_abusive_threshold === true ||
    isRateBelowAbusiveThreshold(
      contract?.interest_rate_monthly_value,
      contract?.interest_rate_average_monthly_value,
      contract?.category
    );
  if (!isBelow) {
    return true;
  }
  const message = formatRateAbusivenessMessage(
    contract?.interest_rate_monthly_value,
    contract?.interest_rate_average_monthly_value,
    contract?.rate_excess_percent
  );
  return window.confirm(`${message}\n\nDeseja gerar o documento mesmo assim?`);
};
